export default __webpack_public_path__ + "static/media/10607-dog-avatar.03e33108.png";